jQuery(document).ready(function ($) {
    function variationsResponsive($win) {
        if( '' != $('input.variation_id').val() ) {
            var var_id = $('input.variation_id').val();
            var image_id = $("figure[data-variation='" + var_id +"']");

            // Slide to image on desktop
            if($(image_id).length && $win.width() > 993){
                $('html, body').animate({ scrollTop: image_id.offset().top}, 500);
            }

            // Change active slide on tablet & mobile
            else if ($(image_id).length && $win.width() <= 992){
                var slide = $(".slick-slider [data-variation='" + var_id +"']");
                var slideIndex = slide.data("slick-index");
                $(".woocommerceSingle__gallery-slider").slick("goTo", slideIndex);
                $(".woocommerceSingle__gallery-thumbnails").slick("goTo", slideIndex);

                // Slide to woocommerce slider
                $('html, body').animate({ scrollTop: $(".woocommerceSingle__gallery-slider").offset().top - 82}, 500);
            }
        }
    }
    $('input.variation_id').change( 
        function(){
            var win = $(window);
            variationsResponsive(win);
        }
    );
});